import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const formatTimeFromNow = (time: string | Date) => {
  return dayjs(time).fromNow();
};
